<template>
  <v-form @submit.prevent="submit">
    <v-text-field
      v-model="band.name"
      label="Nome"
      :loading="loading"
      :error-messages="error.name || ''"
      required
    ></v-text-field>
    <autocomplete
      v-model="band.referent"
      :error-messages="error.referent"
      :model="personModel"
      item-text="name"
      item-value="id"
      label="Referente"
      chips
    ></autocomplete>
    <autocomplete
      v-model="band.members"
      :error-messages="error.members"
      :model="personModel"
      item-text="name"
      item-value="id"
      chips
      label="Membri"
      multiple
    ></autocomplete>
    <form-actions :loading="loading" @undo="reset" @submit="submit" />
  </v-form>
</template>

<script>
import { cloneDeep } from "@/lodash"

import models from "@/models"

export default {
  props: {
    withData: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      band: {},
      personModel: models.Person,
    }
  },
  watch: {
    withData: {
      handler: "reset",
      deep: true,
    },
  },
  methods: {
    reset() {
      this.band = cloneDeep(this.withData)
    },
    submit() {
      this.$emit("submit", this.band)
    },
  },
}
</script>
